/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBaseClientRepresentationFromDiscriminatorValue, serializeBaseClientRepresentation } from '../../../../../../models/index.js';
/**
 * Uri template for the request builder.
 */
export const VersionItemRequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}/clients/{version}/{id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const VersionItemRequestBuilderRequestsMetadata = {
    delete: {
        uriTemplate: VersionItemRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: VersionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
    },
    patch: {
        uriTemplate: VersionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
        requestBodyContentType: "application/merge-patch+json",
        requestInformationContentSetMethod: "setStreamContent",
    },
    put: {
        uriTemplate: VersionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory: createBaseClientRepresentationFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBaseClientRepresentation,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map